/* ==========================================================
   Velari custom scripts
   Loaded site-wide from sections/announcement-bar.liquid.
   ========================================================== */

/* ----------------------------------------------------------
   Impact-style swipe dots for mobile sliders. Dawn's slider
   only ships a numeric "1 / 3" counter, so this builds real
   dots from the slides and wires them to native scroll.
   ---------------------------------------------------------- */
(function () {
  function buildDots(sliderComponent) {
    if (sliderComponent.dataset.velariDots === 'ready') return;

    var list = sliderComponent.querySelector('ul.slider');
    if (!list) return;

    var slides = list.querySelectorAll('.slider__slide');
    if (slides.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'velari-dots large-up-hide';

    Array.prototype.forEach.call(slides, function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'velari-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        list.scrollTo({ left: slide.offsetLeft - list.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(dot);
    });

    sliderComponent.appendChild(dots);
    sliderComponent.dataset.velariDots = 'ready';

    var ticking = null;

    function sync() {
      ticking = null;
      var active = 0;
      var closest = Infinity;

      Array.prototype.forEach.call(slides, function (slide, i) {
        var distance = Math.abs(slide.offsetLeft - list.offsetLeft - list.scrollLeft);
        if (distance < closest) {
          closest = distance;
          active = i;
        }
      });

      var all = dots.querySelectorAll('.velari-dot');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.toggle('is-active', i === active);
      }
    }

    list.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = requestAnimationFrame(sync);
    }, { passive: true });
  }

  function init() {
    var components = document.querySelectorAll('.multicolumn slider-component');
    Array.prototype.forEach.call(components, buildDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* ----------------------------------------------------------
   Header behaviour.

   1. Measures the announcement bar so the sticky header can
      sit directly beneath it rather than under the viewport
      top. Runs on every page.
   2. On pages whose first section is a hero, pulls the main
      content up under the header and toggles a body class at
      scroll top so the header can go transparent.
   ---------------------------------------------------------- */
(function () {
  var AT_TOP_THRESHOLD = 24;
  var headerSection = null;
  var announcementBar = null;
  var ticking = false;

  function measure() {
    var root = document.documentElement;

    if (announcementBar) {
      root.style.setProperty('--velari-ab-h', announcementBar.offsetHeight + 'px');
    }
    if (headerSection) {
      root.style.setProperty('--velari-header-h', headerSection.offsetHeight + 'px');
    }
  }

  function syncScroll() {
    ticking = false;
    document.body.classList.toggle('velari-at-top', window.scrollY <= AT_TOP_THRESHOLD);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(syncScroll);
  }

  function observe(el) {
    if (el && window.ResizeObserver) new ResizeObserver(measure).observe(el);
  }

  function init() {
    document.body.classList.remove('velari-overlay-header', 'velari-at-top');

    announcementBar = document.querySelector('.announcement-bar-section');

    var headerEl = document.querySelector('.header-wrapper');
    headerSection = headerEl ? headerEl.closest('.shopify-section') || headerEl : null;

    measure();
    observe(announcementBar);
    observe(headerSection);

    var main = document.getElementById('MainContent');
    var firstSection = main ? main.querySelector('.shopify-section') : null;

    // Root hero element only: its children use a double underscore
    var hasHero =
      firstSection && firstSection.querySelector('[class*="ai-hero-banner-"]');

    if (hasHero && headerSection) {
      document.body.classList.add('velari-overlay-header');
      syncScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();